var WarmupQuestions = require("lib/academic/WarmupQuestions");

class NonFictionComparisonQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionComparisonQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [DIAGNOSIS_STAGE];
		}

		if (!answers[HAS_READ_TEXT]) {
			return [DIAGNOSIS_STAGE];
		}

		if (answers[HAS_READ_TEXT].includes("no")) {
			return [DIAGNOSIS_STAGE, true];
		}

		if (!answers[COMP_TEXT_TITLE]) {
			return [OTHER_TEXT_STAGE];
		}

		if (this.props.level == "1") {
			if (!answers[TOPIC_COMP]) {
				return [ELEMENTS_STAGE];
			} else {
				return [ELEMENTS_STAGE, true];
			}
		}

		if (!answers[SIMILAR_ELEMENT]) {
			return [ELEMENTS_STAGE];
		}

		if (this.props.level == "2") {
			return [ELEMENTS_STAGE, true];
		}

		if (!answers[SIMILAR_ELEMENT_DESC]) {
			return [DESCRIPTION_STAGE];
		}

		return [DESCRIPTION_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var diagnosisDisplay = (
			<div>
				{ this.props.getTextF("label1", DIAGNOSIS_STAGE) }
				{ this.props.renderDropdownF("choices1", DIAGNOSIS_STAGE, HAS_READ_TEXT, [HAS_READ_TEXT]) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			var otherTextDisplay = (
				<div>
					{ this.props.getTextF("label1", OTHER_TEXT_STAGE) }
					{ this.props.renderInputF(COMP_TEXT_TITLE, [HAS_READ_TEXT, COMP_TEXT_TITLE]) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			if (this.props.level == "1") {
				var selectedText = this.props.answers[NonFictionComparisonQuestion.STEM][COMP_TEXT_TITLE];
				var elementsReplacementsHash = {};
				elementsReplacementsHash[WarmupQuestions.SELECTED_TEXT] = selectedText;

				var additionalElementsDisplay = (
					<span>
						{ this.props.getTextF("label2", ELEMENTS_STAGE, elementsReplacementsHash) }.
					</span>
				);

				var answerKey = TOPIC_COMP;

			} else {
				var answerKey = SIMILAR_ELEMENT;
			}

			var elementsDisplay = (
				<div>
					{ this.props.getTextF("label1", ELEMENTS_STAGE) }
					{ this.props.renderDropdownF("choices1", ELEMENTS_STAGE, answerKey) }
					{ additionalElementsDisplay }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var similarElement = this.props.answers[NonFictionComparisonQuestion.STEM][SIMILAR_ELEMENT];
			var descriptionReplacementsHash = {};
			descriptionReplacementsHash[WarmupQuestions.SIMILAR_ELEMENT] = similarElement;

			var descriptionDisplay = (
				<div>
					{ this.props.getTextF("label1", DESCRIPTION_STAGE, descriptionReplacementsHash) }
					{ this.props.renderInputF(SIMILAR_ELEMENT_DESC) }
				</div>
			);
		}

		return (
			<div>
				{ diagnosisDisplay }
				{ otherTextDisplay }
				{ elementsDisplay }
				{ descriptionDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionComparisonQuestion.STEM = "nfcomp";

// stages
var DIAGNOSIS_STAGE = "diagnosis";
var OTHER_TEXT_STAGE = "othertext";
var ELEMENTS_STAGE = "elements";
var DESCRIPTION_STAGE = "describe";

var STAGES = [
	DIAGNOSIS_STAGE, OTHER_TEXT_STAGE, ELEMENTS_STAGE, DESCRIPTION_STAGE
];

// answer keys
var HAS_READ_TEXT = "has_read_comp_text";
var COMP_TEXT_TITLE = "comp_text_title";
var TOPIC_COMP = "topic_comparison";
var SIMILAR_ELEMENT = "similar_element";
var SIMILAR_ELEMENT_DESC = "similar_element_description";

NonFictionComparisonQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionComparisonQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionComparisonQuestion.js